import SessionReplay, { LDRecord } from '@launchdarkly/session-replay';

import { CILogger } from 'common/log/log.provider';

/** `strict` obfuscates all text and images; `manualStart` records nothing until asked. */
export const createSessionReplayPlugin = (): SessionReplay =>
    new SessionReplay({
        manualStart: true,
        privacySetting: 'strict',
    });

// Matches the prod-host check used for other environment-specific behavior, e.g. useSalesforceChat.ts.
// Checked here (not just via LD environment targeting) so a flag misconfigured on a non-prod
// environment can never start a recording — this is the single choke point every caller goes through.
const isProductionHost = (): boolean => window.location.hostname === 'lxportal.clinicalink.com';

const getRecordingState = (): string | undefined => {
    try {
        return LDRecord.getRecordingState() as string;
    } catch {
        // Plugin not registered yet.
        return undefined;
    }
};

export const isSessionReplayRecording = (): boolean => getRecordingState() === 'Recording';

export const startSessionReplay = async (): Promise<void> => {
    if (!isProductionHost() || isSessionReplayRecording()) {
        return;
    }

    try {
        await LDRecord.start();
    } catch (error) {
        CILogger.getInstance().error('[LaunchDarkly] session replay failed to start', error);
    }
};

export const stopSessionReplay = (): void => {
    try {
        LDRecord.stop();
    } catch (error) {
        CILogger.getInstance().error('[LaunchDarkly] session replay failed to stop', error);
    }
};
